import React from 'react';
import { Link } from 'react-router';
let Storage = require('../../Managers/Storage');
import GlobalHeader from '../../Fragments/GlobalHeader';

const FailedLoading = React.createClass({

    componentWillMount() {
        Storage.clearAll();
    },

    render() {
        return (
            <div>
                <GlobalHeader />

                <div className="container stepless" />

                <question-row class="unpadded no-border">
                    <div className="question-main">
                        <h1>Failed Loading Quote</h1>
                        <div className="question-top">
                            <p>The quote you requested could not be loaded.</p>
                        </div>
                    </div>
                </question-row>

                <question-row class="no-border">
                    <div className="form-navigation">
                        <Link to="/start" className="btn btn-success">Start A New Quote</Link>
                    </div>
                </question-row>
            </div>
        );
    }
});

export default FailedLoading;


/** WEBPACK FOOTER **
 ** ./src/components/Screens/Quote/FailedLoading.js
 **/